import { type FeatureFlag } from '@kalos/kalos-rpc';
import { createContext, useContext } from 'react';

import { evaluateFlag } from './evaluate';
import { type FlagKey } from './registry';

export interface FeatureFlagsContextValue {
  /** Every flag row by key, retired ones included. Empty until ListFlags answers, or if it fails. */
  rows: ReadonlyMap<string, FeatureFlag>;
  /**
   * Reads a flag as of now. Route loaders use it through the router context;
   * components use useFeatureFlag, which reads once per mount.
   */
  isEnabled: (key: FlagKey) => boolean;
}

export function featureFlagsValue(list: readonly FeatureFlag[]): FeatureFlagsContextValue {
  const rows = new Map(list.map((row) => [row.key, row]));
  return { rows, isEnabled: (key) => evaluateFlag(rows, key) };
}

// Without a provider every flag reads as it would after a failed read: off in prod.
export const FeatureFlagsContext = createContext<FeatureFlagsContextValue>(featureFlagsValue([]));

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
